import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, UserService } from '../..';

@Injectable()
export class ThongsochisokhachhangService {

  constructor(private router: Router, private api: ApiService, private userService: UserService) { }

  getThongSoChiSoKhachHang(meterid, thang) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CHISOKHACHHANG.P_GET_CHISO" }),
      para: JSON.stringify({
        v_thang: thang,
        v_meterid: meterid
      })
    };

    return this.api.Excute("api/ExcuteOracle", param);
  }
  getdoisoat_pc1_bacninh(code, tungay, denngay) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_DOISOAT.BAOCAO_DOISOAT_PC1_BACNINH" }),
      para: JSON.stringify({
        v_code: code,
        v_fromdate: tungay,
        v_todate: denngay,
        v_pagenum: 0,
        v_numrecs: 1000
      })
    };

    return this.api.Excute("api/ExcuteOracle", param);
  }
  getdoisoat_nspc(code, tungay, denngay) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_DOISOAT.BAOCAO_DOISOAT_NSPC" }),
      para: JSON.stringify({
        v_code: code,
        v_fromdate: tungay,
        v_todate: denngay,
        v_dk: 0,
        v_pagenum: 0,
        v_numrecs: 1000
      })
    };

    return this.api.Excute("api/ExcuteOracle", param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/thong-so-chi-so-khach-hang/thongsochisokhachhang.service.ts